import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "invite-modal-container" }
const _hoisted_2 = { class: "invite-modal-header" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "success-state"
}
const _hoisted_7 = { class: "success-title" }
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = {
  key: 0,
  class: "role-hint"
}
const _hoisted_10 = {
  key: 1,
  class: "role-hint"
}
const _hoisted_11 = {
  key: 2,
  class: "role-hint"
}
const _hoisted_12 = { class: "invite-footer" }

import { reactive, ref } from 'vue'
import { Close, Check } from '@element-plus/icons-vue'
import { useGolfSecurityGroupStore } from '@/store/golf-security-group'


export default /*@__PURE__*/_defineComponent({
  __name: 'GolfInviteForm',
  emits: ["success", "cancel"],
  setup(__props, { emit: __emit }) {

const emit = __emit
const golfSecurityGroupStore = useGolfSecurityGroupStore()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formRef = ref<any>(null)
const inviteForm = reactive({
  first_name: '',
  last_name: '',
  email: '',
  golf_role: 'admin',
})

const loading = ref(false)
const success = ref(false)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const submitForm = (formEl: any) => {
  if (!formEl) return
  formEl.validate(async (valid: boolean | undefined) => {
    if (valid) {
      try {
        loading.value = true
        await golfSecurityGroupStore.inviteUser({
          email: inviteForm.email as string,
          // We don't have first_name/last_name in the CreateGolfAdminAccount interface yet,
          // but we can pass them in the payload for when the backend is updated.
          first_name: inviteForm.first_name,
          last_name: inviteForm.last_name,
          golf_role: inviteForm.golf_role as any,
        } as any)

        success.value = true

        // Auto-close after 3 seconds
        setTimeout(() => {
          success.value = false
          formEl.resetFields()
          emit('success')
        }, 3000)
      } catch (error) {
        console.error(error)
      } finally {
        loading.value = false
      }
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('golf.roles.invite_team_member')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('golf.roles.send_secure_token')), 1)
      ]),
      _createElementVNode("button", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    (success.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "success-icon-wrapper" }, [
            _createElementVNode("img", {
              src: "/icons_golf_module/User role Invitation Success.svg",
              alt: "Success",
              style: {"width":"32px","height":"32px"}
            })
          ], -1)),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('golf.roles.invitation_sent')), 1),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "success-subtitle" }, " A secure onboarding email has been dispatched via email. ", -1))
        ]))
      : (_openBlock(), _createBlock(_component_el_form, {
          key: 1,
          ref_key: "formRef",
          ref: formRef,
          model: inviteForm,
          "label-position": "top",
          class: "modern-invite-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                prop: "first_name",
                label: _ctx.$t('golf.roles.name'),
                class: "half-width",
                rules: [{ required: true, message: 'Required' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: inviteForm.first_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inviteForm.first_name) = $event)),
                    placeholder: _ctx.$t('golf.roles.eg_first_name'),
                    size: "large"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "last_name",
                label: _ctx.$t('golf.roles.name'),
                class: "half-width",
                rules: [{ required: true, message: 'Required' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: inviteForm.last_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inviteForm.last_name) = $event)),
                    placeholder: _ctx.$t('golf.roles.eg_last_name'),
                    size: "large"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createVNode(_component_el_form_item, {
              prop: "email",
              label: _ctx.$t('golf.common.email'),
              rules: [
          { required: true, message: 'Please input email address' },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: 'blur',
          },
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: inviteForm.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inviteForm.email) = $event)),
                  placeholder: _ctx.$t('golf.roles.eg_email'),
                  size: "large"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "golf_role",
              label: _ctx.$t('golf.roles.role'),
              rules: [{ required: true, message: 'Please select a role' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: inviteForm.golf_role,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inviteForm.golf_role) = $event)),
                  placeholder: _ctx.$t('golf.roles.select_role'),
                  size: "large",
                  style: {"width":"100%"},
                  class: "modern-select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: 
              `${_ctx.$t('golf.roles.admin')} - ${_ctx.$t('golf.roles.role_admin_desc')}`
            ,
                      value: "admin"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: 
              `${_ctx.$t('golf.roles.supervisor')} - ${_ctx.$t(
                'golf.roles.role_supervisor_desc'
              )}`
            ,
                      value: "supervisor"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: 
              `${_ctx.$t('golf.roles.operator')} - ${_ctx.$t(
                'golf.roles.role_operator_desc'
              )}`
            ,
                      value: "operator"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (inviteForm.golf_role === 'admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('golf.roles.role_admin_desc')), 1))
              : (inviteForm.golf_role === 'supervisor')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('golf.roles.role_supervisor_desc')), 1))
                : (inviteForm.golf_role === 'operator')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('golf.roles.role_operator_desc')), 1))
                  : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                class: "cancel-btn",
                size: "large",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('cancel')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('golf.common.cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                class: "submit-btn",
                type: "primary",
                size: "large",
                loading: loading.value,
                disabled: loading.value,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createElementVNode("img", {
                    src: "/icons_golf_module/User role Invite New Team Member - sent invitation.svg",
                    alt: "Invite",
                    style: {"width":"16px","height":"16px","margin-right":"8px","filter":"brightness(0) invert(1)"}
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.roles.invite_team_member')), 1)
                ]),
                _: 1,
                __: [9]
              }, 8, ["loading", "disabled"])
            ])
          ]),
          _: 1
        }, 8, ["model"]))
  ]))
}
}

})